import { PAGE_PATH } from '@utilities/constants';
import { useEffect } from 'react';

export const PAGE_RELOAD_KEY = `checkout_frontend_reload_pathname`;
const CHECKOUT_PATHS = new Set(Object.values(PAGE_PATH));

const isSafari = (): boolean => {
  // We only want to target Safari browsers, as this issue is specific to Safari's handling of the back button.
  const userAgent = navigator.userAgent;
  return /safari/i.test(userAgent) && !/chrome|crios|fxios|edgios|opera|opt\//i.test(userAgent);
};

/***
 * In some cases, specifically in Safari browsers, users may end up on an invalid checkout path (e.g., by using the back button) and sees a broken page.
 * In this scenario, we try to reload the page once to correct the URL.
 * If the path is still invalid after the page reload, we redirect the user to the cart page to avoid an infinite loop.
 ***/
export const useCheckoutPathValidator = () => {
  useEffect(() => {
    if (!isSafari()) {
      return;
    }

    const currentPath = window.location.pathname;

    if (CHECKOUT_PATHS.has(currentPath)) {
      sessionStorage.removeItem(PAGE_RELOAD_KEY);
      return;
    }

    const hasReloadedBefore = sessionStorage.getItem(PAGE_RELOAD_KEY);

    if (!hasReloadedBefore) {
      sessionStorage.setItem(PAGE_RELOAD_KEY, 'true');
      window.location.reload();
    } else {
      sessionStorage.removeItem(PAGE_RELOAD_KEY);
      window.location.href = PAGE_PATH.CART;
    }
  }, []);
};
